export default __webpack_public_path__ + "static/media/zeel ahir.3fc01669.jpg";